export const ComponentReplacementEndpoint = {
  CREATE: '/reporting/replacement/create',
  DELETE: '/reporting/replacement/delete',
  EDIT: '/reporting/replacement/update',
  GET: '/reporting/replacement/get',
  LOAD_REPLACEMENT: '/reporting/replacement/load-replacement',
};
